import { isNone } from '@ember/utils';

import Transform from '@ember-data/serializer/transform';

export default class ObjectTransform extends Transform {
	deserialize(serialized: object | null | undefined): object {
		return isNone(serialized) ? {} : serialized;
	}

	serialize(deserialized: object | null | undefined): object {
		return isNone(deserialized) ? {} : deserialized;
	}
}

declare module '@ember-data/serializer/transform' {
	interface TransformRegistry {
		object: object;
	}
}
